export const COURSE_LIST_REQUEST = "COURSE_LIST_REQUEST";
export const COURSE_LIST_SUCCESS = "COURSE_LIST_SUCCESS";
export const COURSE_LIST_FAILURE = "COURSE_LIST_FAILURE";

export const ADD_COURSE_REQUEST = "ADD_COURSE_REQUEST";
export const ADD_COURSE_SUCCESS = "ADD_COURSE_SUCCESS";
export const ADD_COURSE_FAILURE = "ADD_COURSE_FAILURE";

export const EDIT_COURSE_REQUEST = "EDIT_COURSE_REQUEST";
export const EDIT_COURSE_SUCCESS = "EDIT_COURSE_SUCCESS";
export const EDIT_COURSE_FAILURE = "EDIT_COURSE_FAILURE";

export const DELETE_COURSE_REQUEST = "DELETE_COURSE_REQUEST";
export const DELETE_COURSE_SUCCESS = "DELETE_COURSE_SUCCESS";
export const DELETE_COURSE_FAILURE = "DELETE_COURSE_FAILURE";

export const COURSE_BY_ID_REQUEST = "COURSE_BY_ID_REQUEST";
export const COURSE_BY_ID_SUCCESS = "COURSE_BY_ID_SUCCESS";
export const COURSE_BY_ID_FAILURE = "COURSE_BY_ID_FAILURE";

export const PENDING_COURSE_ENROLLMENT_EDUCATORS_REQUEST =
  "PENDING_COURSE_ENROLLMENT_EDUCATORS_REQUEST";
export const PENDING_COURSE_ENROLLMENT_EDUCATORS_SUCCESS =
  "PENDING_COURSE_ENROLLMENT_EDUCATORS_SUCCESS";
export const PENDING_COURSE_ENROLLMENT_EDUCATORS_FAILURE =
  "PENDING_COURSE_ENROLLMENT_EDUCATORS_FAILURE";

export const COURSE_MATERIAL_LIST_REQUEST = "COURSE_MATERIAL_LIST_REQUEST";
export const COURSE_MATERIAL_LIST_SUCCESS = "COURSE_MATERIAL_LIST_SUCCESS";
export const COURSE_MATERIAL_LIST_FAILURE = "COURSE_MATERIAL_LIST_FAILURE";

export const ADD_COURSE_MATERIAL_REQUEST = "ADD_COURSE_MATERIAL_REQUEST";
export const ADD_COURSE_MATERIAL_SUCCESS = "ADD_COURSE_MATERIAL_SUCCESS";
export const ADD_COURSE_MATERIAL_FAILURE = "ADD_COURSE_MATERIAL_FAILURE";

export const EDIT_COURSE_MATERIAL_REQUEST = "EDIT_COURSE_MATERIAL_REQUEST";
export const EDIT_COURSE_MATERIAL_SUCCESS = "EDIT_DOCUMENT_SUCCESS";
export const EDIT_COURSE_MATERIAL_FAILURE = "EDIT_COURSE_MATERIAL_FAILURE";

export const COURSE_MATERIAL_BY_ID_REQUEST = "COURSE_MATERIAL_BY_ID_REQUEST";
export const COURSE_MATERIAL_BY_ID_SUCCESS = "COURSE_MATERIAL_BY_ID_SUCCESS";
export const COURSE_MATERIAL_BY_ID_FAILURE = "COURSE_MATERIAL_BY_ID_FAILURE";

export const DELETE_COURSE_MATERIAL_REQUEST = "DELETE_COURSE_MATERIAL_REQUEST";
export const DELETE_COURSE_MATERIAL_SUCCESS = "DELETE_COURSE_MATERIAL_SUCCESS";
export const DELETE_COURSE_MATERIAL_FAILURE = "DELETE_COURSE_MATERIAL_FAILURE";

export const GET_SCO_LIST_BY_COURSE_ID_REQUEST =
  "GET_SCO_LIST_BY_COURSE_ID_REQUEST";
export const GET_SCO_LIST_BY_COURSE_ID_SUCCESS =
  "GET_SCO_LIST_BY_COURSE_ID_SUCCESS";
export const GET_SCO_LIST_BY_COURSE_ID_FAILURE =
  "GET_SCO_LIST_BY_COURSE_ID_FAILURE";

export const UPDATE_SCO_LIST_REQUEST = "UPDATE_SCO_LIST_REQUEST";
